 const INITIAL_STATE = {
    signUp: '',
    dataLoad: {
      login: '',
      fetchGraphData: '',
      fetchComplaints:'',
      detailLoadStatus:''
    },
  };

  export default function appStatuses(state = INITIAL_STATE, { type, payload }) {
    switch (type) {
      case 'login_FULFILLED':
        return {
          ...state,
          login: '',
        };

      case 'login_PENDING':
        return {
          ...state,
          login: 'PENDING',
        };

      case 'login_REJECTED':
        return {
          ...state,
          login: 'REJECTED',
        };
      case 'data-load_PENDING':
        return {
          ...state,
          dataLoad: {
            ...state.dataLoad,
            [payload.key]: 'PENDING',
          },
        };

      case 'data-load_FULFILLED':
        return {
          ...state,
          dataLoad: {
            ...state.dataLoad,
            [payload.key]: '',
          },
        };

      case 'data-load_REJECTED':
        return {
          ...state,
          dataLoad: {
            ...state.dataLoad,
            [payload.key]: 'REJECTED',
          },
        };

      case 'app/reset': {
        return INITIAL_STATE;
      }

      default:
        return state;
    }
  }
